var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.005 1.129C17.601 9.89967 15.0403 16.493 13.323 20.909C13.3077 20.9703 13.2847 21.001 13.254 21.001C13.2233 21.001 13.1927 20.9703 13.162 20.909C12.9473 20.4183 12.794 20.058 12.702 19.828L9.528 12.376C9.482 12.2687 9.39767 12.1843 9.275 12.123C6.745 11.1263 4.01567 10.0607 1.087 8.926C1.07167 8.91067 1.041 8.89533 0.995 8.88C0.949 8.84933 0.933667 8.81867 0.949 8.788C0.964333 8.75733 1.00267 8.73433 1.064 8.719L20.821 0.967999C20.9743 0.906666 21.051 0.883665 21.051 0.898999C21.0663 0.914333 21.051 0.991 21.005 1.129Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.7a7f8ffbf86c7892ec6985f00afdfbe7.svg";
export { ForwardRef as ReactComponent };